<template>
  <ModuleHeader code="batch" />
</template>
<script>
import ModuleHeader from "@/components/common/ModuleHeader.vue";
export default {
  name: 'Batch',
  components: {ModuleHeader}
}
</script>